import React, { useState, useLayoutEffect } from 'react';
import styled from 'styled-components';
import loginbg from 'Components/auth/assets/img/login-bg.png';
import { Col, Row } from 'antd';
import { secondaryFont } from 'Utils/utilsStyle';
import PasswordUpdated from 'Components/auth/components/PasswordUpdated';
import { useSearchParams } from 'react-router-dom';
import PrimaryWhiteLogo from '../../Components/common/assets/images/PrimaryWhiteLogo';
import PasswordReset from '../../Components/auth/components/PasswordReset';
import LoginContainer from '../../Components/auth/Login/LoginContainer';
import ForgotPassword from '../../Components/auth/components/ForgotPassword';
import ForgotUsername from '../../Components/auth/components/ForgotUsername';
// import Nav from '../../Components/auth/components/Nav';
// styles goes here
import 'Components/auth/assets/style.css';
import GlobalStyle from '../../Components/auth/components/GlobalStyle';

import ResetNewPassword from '../../Components/auth/components/ResetNewPassword';

const Wrapper = styled.div`
  background-image: url(${loginbg});
  box-sizing: border-box;
  background-size: cover;
  min-height: 100vh;
  overflow: hidden !important;
  .margined-image {
    @media all and (max-width: 768px){
      width: 220px;
    }
    width: 370px;
    margin-top: 0px;
  }
`;
const Header = styled.header`
  padding: 30px 75px 0 75px;
  @media all and (max-width: 900px) {
      padding: 30px 75px 0 45px;
  }
  @media all and (max-width: 1439px), all and (max-height: 749px) {
    padding: 30px 75px 0 75px;
  }
   @media all and (max-width: 768px) {
    padding: 30px 75px 0 17px;
   }
  svg {
    width: auto;
    margin-top: -30px;
  }
`;

const Content = styled.section`
  &.mobileContainer {
    padding: 40px 0px;
  }
  padding: 25px 75px 0 75px;
  min-height: calc(100vh - 125px);
  @media all and (max-width:1050px) {
    padding: 25px 25px 0 25px;
  }
  @media all and (max-width: 1439px) {
    min-height: calc(100vh - 135px);
  }
  @media all and (max-height: 992px) {
    max-height: calc(100vh - 135px);
    position: relative;
  }
  .login-box {
    max-width: 768px;
    @media all and (max-width: 1439px), all and (max-height: 749px) {
      max-width: 370px;
    }
  }
  .forgot {
    max-width: 768px;
    @media all and (max-width: 1439px), all and (max-height: 749px) {
      max-width: 450px;
    }
  }
  &.content-section {
   .data-row {
    .first-col {
      @media all and (max-width:992px){
        display:none;
      }
    }
    .second-col {
      @media all and (max-width:992px){
        max-width: 100%;
        width: 100%;
        flex: 100%;
        justify-content: center;
      }
    }
   }
  }
`;
const Tagline = styled.h1`
  padding-left: 60px;
  margin: 0;
  font-size: 50px;
  line-height:60px;
  font-weight: 600;
  color: #fff;
  font-family: ${secondaryFont};
  @media all and (max-width: 1439px) {
    font-size: 32px;
    line-height: 35px;
  }
`;

const Login = function Login() {
  const [redirectPath, setRedirectPath] = useState('');
  const [searchParams] = useSearchParams();
  useLayoutEffect(() => {
    const option = searchParams.get('option') ?? '';
    if (option === 'reset_password') {
      setRedirectPath('setNewPassword');
    }
  }, []);

  function conditionalRendering() {
    switch (redirectPath) {
      case 'username':
        return (
          <ForgotUsername
            setRedirectPath={(value) => {
              setRedirectPath(value);
            }}
          />
        );
      case 'password':
        return (
          <ForgotPassword
            setRedirectPath={(value) => {
              setRedirectPath(value);
            }}
          />
        );
      case 'resetPassword':
        return (
          <PasswordReset
            setRedirectPath={(value) => {
              setRedirectPath(value);
            }}
          />
        );
      case 'setNewPassword':
        return (
          <ResetNewPassword
            setRedirectPath={(value) => {
              setRedirectPath(value);
            }}
          />
        );
      case 'passwordUpdated':
        return (
          <PasswordUpdated />
        );
      default:
        return (
          <LoginContainer
            setRedirectPath={(value) => {
              setRedirectPath(value);
            }}
          />
        );
    }
  }

  return (
    <>
      <GlobalStyle />
      <Wrapper>
        <div className="container-fluid" style={{ minHeight: '100vh' }}>
          <Header>
            <Row>
              <Col span={12}>
                <PrimaryWhiteLogo className="margined-image" />
              </Col>
              <Col span={12} className="d-flex justify-content-end">
                {/* <Nav /> */}
              </Col>
            </Row>
          </Header>
          <Content className="d-flex align-items-center content-section">
            <Row className="data-row w-100">
              <Col span={16} className="d-flex align-items-center first-col">
                <Tagline>
                  Personality-Driven Selling,
                  <br />
                  {' '}
                  Sell Smarter, Sell Faster
                </Tagline>
              </Col>
              {/* forgot class for forget page */}
              <Col span={8} className="d-flex justify-content-end login-box second-col">
                {redirectPath !== undefined ? (
                  conditionalRendering()
                ) : (
                  <LoginContainer
                    setRedirectPath={(value) => {
                      setRedirectPath(value);
                    }}
                  />
                )}
              </Col>
            </Row>
          </Content>
        </div>
      </Wrapper>
    </>
  );
};

export default Login;
